<template>
    <div class="content1">
        <div class="nav_menu">
            <Menu :menu="menu"></Menu>
        </div>
        <div class="table">
            <transition
                    name="fade-transform"
                    mode="out-in"
            >
                <router-view :key="$route.fullPath"></router-view>
            </transition>
        </div>
    </div>
</template>

<script>
    import Menu from '@/components/Menu'
    import storage from 'store'
    import {
      page,
    } from '@/api/meet/index'
    export default {
        components: {
            Menu
        },
        data() {
            return {
                menu: []
            }
        },
        created() {
            this.getList();
        },
        methods: {
            getList() {
                let that = this;
                let query = {
                    pageNum: 1,
                    pageSize: 1,
                    totalRecord: 0,
                    name: "",
                    type: '1',
                };
                let f = JSON.parse(JSON.stringify(query));
                page(f).then(res => {
                    if (res.status == 1) {
                        let role = storage.get('role');
                        that.menu = [
                            {
                                text: '常委会会议资料',
                                to: '/meeting/cw',
                                show: role['cw']
                            },
                            {
                                text: '代表大会会议资料',
                                to: '/meeting/db',
                                show: role['db']
                            },
                            {
                                text: '主任会议资料',
                                to: '/meeting/zr',
                                show: role['db']
                            },
                            {
                                text: '其他文件资料',
                                to: '/meeting/qt',
                                show: role['qt']
                            },
                            {
                                text: '审议意见卡',
                                to: `/meeting/files/syyjm/${res.rows[0].id}/cw`,
                                show: role['syyjm']
                            },
                        ]
                    }
                })
            },
        }
    }
</script>
<style lang="scss" scoped>
    .content1 {
        display: flex;
        height: 100%;

        .nav_menu {
            width: 200px;
            margin-right: 30px;
        }

        .table {
            flex-grow: 1;
            flex-shrink: 0;
            width: 0;
        }
    }
</style>